import { baseTheme } from 'utils/themes/base'

import { ThemeI } from 'types/styled'

export const lightTheme: ThemeI = {
  ...baseTheme,
}
